<template>
  <div class="card">
    <div class="card-body">
      <div class="prevent-select ">
        <right-panel v-if="!hideCreateButton" class="float-right  mb-2 mr-2" id="sidebar-edit-organization" width="600px" icon="bx bx-plus" @hidden="rightPanelClosed">
          <div class="pl-2 pr-2">
            <Form :hide-library="true" />
          </div>
        </right-panel>

        <div style="width: 150px; height: 60px;">
          <div class="search-box mr-2 mb-2 d-inline-block">
            <div class="position-relative">
              <input v-model="nameFilter" type="text" class="form-control" placeholder="Ara..." />
              <i class="bx bx-search-alt search-icon"></i>
            </div>
          </div>
        </div>

        <div style="clear:both"></div>

        <h4 class="card-title mb-4">
          <span class="text-primary">{{ workspace.name }}</span>

          {{ $t("workspace.organizations-accessible") }}
        </h4>
        <div class="table-responsive mb-0" v-if="pagination && pagination.docs.length > 0">
          <table class="table table-centered table-nowrap">
            <tbody>
              <tr v-for="item in pagination.docs" :key="item._id" class="hider">
                <td style="width: 50px;">
                  <letter-avatar :name="item.name" :image="item.logo" variant="secondary"> </letter-avatar>
                </td>
                <td>
                  <h5 class="font-size-14 m-0">
                    {{ item.name }}
                  </h5>
                </td>
                <td>
                  <span v-b-tooltip.hover.left :title="$t('common.owner')" class="arrow">
                    <letter-avatar :showName="true" :name="item.createdBy.name" :image="item.createdBy.avatar" variant="secondary" />
                  </span>
                </td>
                <td>
                  <span @click="edit(item)" class="hand text-primary mr-4">
                    <i class="bx bx-pencil text-primary hand ml-2 "></i> <span>{{ $t("common.edit") }}</span>
                  </span>

                  <span @click="deleteById(item._id)" class="hand text-danger">
                    <i class="bx bx-trash-alt"></i>
                    {{ $t("common.delete") }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <content-loading v-if="loading" />

        <empty v-if="!loading && (!pagination || pagination.docs.length == 0)">
          <h5 class="text-center">
            {{ $t("common.not-found") }}
          </h5>
        </empty>

        <template v-if="pagination">
          <div class="d-flex justify-content-center my-3">
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
            </ul>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import Form from "@modules/core/organization/workspace-organization-form";
export default {
  props: { hideCreateButton: { type: Boolean } },
  components: { Form },
  data() {
    return {
      request: {
        options: { page: 1, limit: 10, sort: { name: "asc" } },
        query: {},
      },
      nameFilter: undefined,
    };
  },

  watch: {
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounceMixin(() => this.paginate());
      },
    },
    nameFilter(n) {
      this.request.query = {
        ...this.request.query,
        name: { value: n },
      };
    },
  },

  computed: {
    workspace() {
      return this.$store.getters["switchWorkspace/selected"];
    },
    isUpdating() {
      return this.$store.getters["workspace/isUpdating"];
    },

    pagination() {
      return this.$store.getters["workspace/paginateWorkspaceOrganization"];
    },
    loading() {
      return this.$store.getters["workspace/isLoading"];
    },
  },
  methods: {
    async paginate() {
      await this.$store.dispatch("workspace/fetchWorkspaceOrganizations", { id: this.workspace._id, request: this.request });
    },
    edit(item) {
      this.$store.commit(`workspaceOrganization/editedOrganization`, item);
      this.$root.$emit("bv::toggle::collapse", "sidebar-edit-organization");
    },
    rightPanelClosed() {
      this.$store.commit("organization/editedOrganization", null);
      this.paginate();
    },

    async deleteById(id) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("organization/delete", id);
        this.paginate();
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
  },
};
</script>
